import { useAuth } from '@/contexts/AuthContext';

export function usePermissions() {
	const { user } = useAuth();
	const roles = user?.roles?.map((r) => r.roleName) ?? [];

	return {
		canManageAssets: roles.includes('Admin') || roles.includes('GlobalAdmin') || roles.includes('OrganisationAdmin'),
		canManageWorkOrders:
			roles.includes('Planner') ||
			roles.includes('Admin') ||
			roles.includes('GlobalAdmin') ||
			roles.includes('OrganisationAdmin'),
		isFieldTech: roles.length > 0 && roles.every((r) => r === 'FieldTech'),
		// Platform-only capabilities — never delegated to OrganisationAdmin. `canChooseOrganisation` gates
		// the org filter on register lists and the Organisation field on create forms, not a session switch.
		canManageOrganisations: roles.includes('GlobalAdmin'),
		canChooseOrganisation: roles.includes('GlobalAdmin'),
		// Cosmetic: the API policy (CanReadResourceCapacity) is the real boundary. Not a platform-only
		// capability. Planner and Admin read it too; the API scopes their rows to their sites.
		canViewResourceCapacity:
			roles.includes('GlobalAdmin') ||
			roles.includes('OrganisationAdmin') ||
			roles.includes('Admin') ||
			roles.includes('Planner'),
		isGlobalAdmin: roles.includes('GlobalAdmin'),
	};
}
